export default __webpack_public_path__ + "static/media/three.6507395c.jpg";